import CssBaseline from "@material-ui/core/CssBaseline"
import { MuiThemeProvider } from "@material-ui/core/styles"
import { CacheProvider, ThemeProvider } from "@emotion/react"
import { StylesProvider } from "@material-ui/styles"
import ConnectedIntlProvider from "app/components/ConnectedIntlProvider"
import AppRouter from "app/routes/router"
import { Router } from "react-router-dom"
import React, { Suspense } from "react"
import { Provider } from "react-redux"
import LoadingScreen from "components/LoadingScreen"
import theme from "theme"
import { cache } from "@emotion/css"
import { MuiPickersUtilsProvider } from "@material-ui/pickers"
import MomentUtils from "@date-io/moment"
import store, { history } from "./store"

function App() {
  return (
    <CacheProvider value={cache}>
      <StylesProvider injectFirst={true}>
        <MuiThemeProvider theme={theme}>
          <ThemeProvider theme={theme}>
            <Provider store={store}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <CssBaseline />
                <ConnectedIntlProvider>
                  <Router history={history}>
                    <Suspense fallback={<LoadingScreen />}>
                      <AppRouter />
                    </Suspense>
                  </Router>
                </ConnectedIntlProvider>
              </MuiPickersUtilsProvider>
            </Provider>
          </ThemeProvider>
        </MuiThemeProvider>
      </StylesProvider>
    </CacheProvider>
  )
}

export default App
